<template>
  <!-- Prepared capture owns its actor/session permission lease and must mount without a network-only event-view query. -->
  <slot v-if="['offline-capture', 'session-capture'].includes(String(route.name)) || !view.active.value" />
  <div v-else-if="view.query.isPending.value" class="pa-4" role="status"><v-progress-linear indeterminate />{{ t('eventView.loading') }}</div>
  <v-alert v-else-if="view.query.isError.value" class="ma-4" type="error">{{ t('eventView.error') }}<v-btn variant="text" @click="view.query.refetch()">{{ t('common.actions.refresh') }}</v-btn></v-alert>
  <slot v-else-if="view.mode.value && (view.isHome.value || route.meta.eventView === 'shared' || view.mode.value === requiredView)" />
  <section v-else class="pa-4" aria-live="polite">
    <v-alert type="info" variant="tonal">{{ t(view.mode.value ? 'eventView.otherView' : 'tryoutHome.errors.noAccess', { view: t(requiredView === 'athlete' ? 'tryoutHome.view.athlete' : 'tryoutHome.view.staff') }) }}</v-alert>
    <v-btn v-if="view.canChoose.value" class="mt-3 mr-2" @click="view.select(requiredView)">{{ t('eventView.switchTo', {view: t(requiredView === 'athlete' ? 'tryoutHome.view.athlete' : 'tryoutHome.view.staff')}) }}</v-btn>
    <v-btn class="mt-3" :to="view.home.value">{{ t('participantList.nav.eventHome') }}</v-btn>
  </section>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useEventView } from '@/composables/useEventView'
import { useTryoutSessionInvalidation } from '@/composables/useTryoutContext'
import type { EventView } from '@/stores/eventView'
const route=useRoute(),{t}=useI18n(),view=useEventView()
// New event screens must opt into athlete access; operational pages default to staff.
const requiredView=computed<EventView>(()=>route.meta.eventView === 'athlete' ? 'athlete' : 'staff')
useTryoutSessionInvalidation(computed(()=>view.scope.value.clubId),computed(()=>view.scope.value.seasonId),computed(()=>view.scope.value.eventId))
</script>
